import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function DocumentPreview() {
  const { id } = useParams();
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    const fetchDoc = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/document/${id}`);
        setDoc(res.data);
      } catch (err) {
        console.error("Error loading document:", err);
      }
    };
    fetchDoc();
  }, [id]);

  if (!doc) return <div className="p-6">Loading...</div>;

  return (
    <div className="p-6">
      <h1 className="text-xl font-bold mb-4">{doc.title}</h1>
      <div className="w-full h-[80vh] border rounded-lg shadow-lg overflow-hidden">
        <iframe
          src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${doc.file}`}
          title="PDF Preview"
          className="w-full h-full"
        />
      </div>
    </div>
  );
}

export default DocumentPreview;
